import Swiper, {Pagination, Navigation, Keyboard, EffectFade} from "swiper";
import {isValidTel, isValidMail} from "@main/helpers/is-valid-field";
import focusManager from "focus-manager";
import {ToggleScroll} from "@main/components/toggle-scroll";

const INDEX_FIRST_SLIDE = 0;
const INDEX_LAST_SLIDE = 2;
/** Класс модального окна с заявкой на подбор специалиста. */
class RecruitmentModal {
    swiper
    
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.documentEl = this.el.closest("body");
        this.modal = this.documentEl.querySelector(".js-modal-recruitment");
        this.slider = this.modal.querySelector(".js-swiper-recruitment");
        this.openModalButton = this.el.querySelector(".js-open-modal-recruitment");

        this.createSlider();
        this.blockNavigationNext();
        this.listenEvents();
    }

    /**
     * Прослушивание событий.
     * 
     * @returns {void}
     */
    listenEvents() {
        this.openModalButton.addEventListener("click", () => {
            this.modal.classList.add("shown");
            ToggleScroll.disable(this.modal);
            focusManager.capture(this.modal);
            this.swiper.slideTo(0, 0);  
        })
        
        this.swiper.on("activeIndexChange", () => {
            this.activeIndex = this.swiper.activeIndex;
            this.activeSlide = this.swiper.slides[this.activeIndex];
            this.inputs = this.activeSlide.querySelectorAll("input");

            this.changeNavigationLocation();            
            this.showBtnSubmitOnLastSlide();
            this.validationOnInput();
        })

        this.swiper.navigation.nextEl.addEventListener("click", () => {
            this.validationSlideForm();
        })
        
        this.validationOnInput();
    }

    /**
     * Валидация при вводе в поле.
     * 
     * @returns {void}
     */
    validationOnInput() {
        this.inputs.forEach(input => {            
            input.addEventListener("input", () => {
                if (input.classList.contains("js-number-input")) {
                    input.value = input.value.replace(/[^\d]/g,"");
                }
                
                this.validationSlideForm();                
            })
        })
    }

    /**
     * Валидация полей активного слайда.
     * 
     * @returns {void}
     */
    validationSlideForm() {
        const activeIndex = this.swiper.activeIndex;
        const activeSlide = this.swiper.slides[activeIndex];
        
        this.requiredNodes = activeSlide.querySelectorAll("[required]");
        this.inputs = activeSlide.querySelectorAll("input");
        this.telField = activeSlide.querySelector(".js-tel-input");
        this.telFieldParent = this.telField?.parentElement;
        this.telErrorTextNode = this.telFieldParent?.querySelector(".error");
        this.mailField = activeSlide.querySelector(".js-mail-input");
        this.mailFieldParent = this.mailField?.parentElement;
        this.mailErrorTextNode = this.mailFieldParent?.querySelector(".error");

        let isValid = true;

        this.requiredNodes.forEach(node => {
            if (!node.value.trim().length) {               
                isValid = false;
            } else {
                isValid = true;
            }
        });

        if (
            this.telField &&
            !isValidTel(this.telField) &&
            this.telField.value.length !== 0
        ) {
            isValid = false;
        }

        if (
            this.mailField &&
            this.mailField.value.length !== 0 &&
            !isValidMail(this.mailField)
        ) {
            isValid = false;
        }

        if (isValid) {
            this.unblockNavigationNext();
            if (this.swiper.activeIndex === INDEX_LAST_SLIDE) {
                this.modal.querySelector(".js-form-submit-btn").removeAttribute("disabled");
            } 
        } else {
            this.blockNavigationNext();
            if (this.swiper.activeIndex === INDEX_LAST_SLIDE) {
                this.modal.querySelector(".js-form-submit-btn").setAttribute("disabled", "disabled");
            } 
        }

        this.swiper.updateAutoHeight(0);
    }

    /**
     * Инициализация слайдера.
     * 
     * @returns {void} 
     */
    createSlider() {
        this.swiper = new Swiper(this.slider, {
            slidesPerView: 1,
            modules: [Pagination, Navigation, Keyboard, EffectFade],
            autoHeight: true,
            allowTouchMove: false,
            observeParents: true,
            observeSlideChildren: true,
            observer: true,
            keyboard: {
                enabled: true,
            },
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            navigation: {
                nextEl: ".js-recruitment-next",
                prevEl: ".js-recruitment-prev"
            },
            pagination: {
                el: ".js-recruitment-pagination",
                clickable: false,
                renderBullet: (index, className) => {
                    return "<span class=\"" + className + "\">" + (index + 1) + "</span>";
                },
            },
        });

        this.activeIndex = this.swiper.activeIndex;
        this.activeSlide = this.swiper.slides[this.activeIndex];
        this.inputs = this.activeSlide.querySelectorAll("input");
    }

    /**
     * Изменение расположения навигационных кнопок в зависимости от активного слайда.
     * 
     * @returns {void} 
     */
    changeNavigationLocation() {
        if (this.swiper.activeIndex !== INDEX_FIRST_SLIDE) {
            this.swiper.el.classList.add("first-slide-active");
        } else {
            this.swiper.el.classList.remove("first-slide-active");
        }
    }

    /**
     * Действия при переходе к последнему слайду.
     * 
     * @returns {void} 
     */
    showBtnSubmitOnLastSlide() {
        if (this.swiper.activeIndex === INDEX_LAST_SLIDE) {
            this.swiper.el.classList.add("last-slide-active");
        } else {
            this.swiper.el.classList.remove("last-slide-active");
        }
    }

    /**
     * Блокировать кнопку навигации "Далее".
     * 
     * @returns {void} 
     */
    blockNavigationNext() {
        this.swiper.navigation.nextEl.classList.add("swiper-button-disabled");
    }

    /**
     * Разблокировать кнопку навигации "Далее".
     * 
     * @returns {void} 
     */
    unblockNavigationNext() {
        this.swiper.navigation.nextEl.classList.remove("swiper-button-disabled");
    }
}

window.addEventListener("load", () => {
    document.querySelectorAll(".js-recruitment").forEach((item) => new RecruitmentModal(item));
});
